import { ReferencePoint } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

export interface ReferencePointInput {
  name: string;
  radius: number;
  center_latitude?: string | null;
  center_longitude?: string | null;
  polygon_coordinates?: string | null;
  safe_zone?: boolean;
  is_headquarters?: boolean;
  users?: number[];
}

export const referencePointService = {
  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<DefaultResponse<ReferencePoint>>(
      "/reference_point",
      {
        params: {
          page: page ?? null,
          per_page: per_page ?? null,
          search: search,
          ...filters,
        },
      },
    );
    return response.data;
  },

  async show(id: number) {
    const response = await api.get<DefaultResponse<ReferencePoint, false>>(
      `/reference_point/${id}`,
    );
    return response.data;
  },

  async create(data: ReferencePointInput) {
    const response = await api.post("/reference_point", {
      name: data.name,
      radius: data.radius,
      center_latitude: data.center_latitude,
      center_longitude: data.center_longitude,
      polygon_coordinates: data.polygon_coordinates,
      safe_zone: data.safe_zone,
      is_headquarters: data.is_headquarters,
      users: data.users,
    });
    return response.data;
  },

  async update(id: number, data: ReferencePointInput) {
    const response = await api.put(`/reference_point/${id}`, {
      name: data.name,
      radius: data.radius,
      center_latitude: data.center_latitude,
      center_longitude: data.center_longitude,
      polygon_coordinates: data.polygon_coordinates,
      safe_zone: data.safe_zone,
      is_headquarters: data.is_headquarters,
      users: data.users,
    });
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete(`/reference_point/${id}`);
    return response.data;
  },
};
